export const DEFAULT_PRODUCT_BANNERS = {
  featured: {
    name: "Featured Product",
    backgroundColor: "#111827",
  },
  new_arrival: {
    name: "New Arrival",
    backgroundColor: "#d4af37",
  },
};

export const PRODUCT_BANNER_TYPES = [
  { id: "featured", label: "Featured Product" },
  { id: "new_arrival", label: "New Arrival" },
];

export const SYSTEM_PRODUCT_BANNER_IDS = PRODUCT_BANNER_TYPES.map((bannerType) => bannerType.id);

function createBannerId() {
  return `banner_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

function normalizeHexColor(color, fallbackColor) {
  const normalizedColor = String(color || "").trim();
  return /^#([0-9a-fA-F]{6})$/.test(normalizedColor) ? normalizedColor : fallbackColor;
}

export function normalizeProductBanners(value) {
  const rawValue = value && typeof value === "object" && !Array.isArray(value) ? value : {};

  return Object.entries(rawValue).reduce((banners, [bannerId, rawBanner]) => {
    if (!rawBanner || typeof rawBanner !== "object") {
      return banners;
    }

    const isSystemBanner = SYSTEM_PRODUCT_BANNER_IDS.includes(bannerId);
    const fallbackBanner = isSystemBanner
      ? DEFAULT_PRODUCT_BANNERS[bannerId]
      : { name: "New Banner", backgroundColor: "#374151" };

    return {
      ...banners,
      [bannerId]: {
        name: String(rawBanner.name || fallbackBanner.name).trim() || fallbackBanner.name,
        backgroundColor: normalizeHexColor(rawBanner.backgroundColor, fallbackBanner.backgroundColor),
      },
    };
  }, {});
}

export function createDefaultProductBanners() {
  return normalizeProductBanners(DEFAULT_PRODUCT_BANNERS);
}

export function createProductBanner(type) {
  if (!DEFAULT_PRODUCT_BANNERS[type]) {
    return null;
  }

  return {
    ...DEFAULT_PRODUCT_BANNERS[type],
  };
}

export function createCustomProductBanner() {
  return {
    id: createBannerId(),
    banner: {
      name: "New Banner",
      backgroundColor: "#374151",
    },
  };
}

export function getMissingProductBannerTypes(banners) {
  return PRODUCT_BANNER_TYPES.filter((bannerType) => !banners?.[bannerType.id]);
}

export function getProductBannerLabel(bannerId, banner) {
  const systemBanner = PRODUCT_BANNER_TYPES.find((bannerType) => bannerType.id === bannerId);
  return systemBanner?.label || banner?.name || "Custom Banner";
}

export function getContrastTextColor(backgroundColor) {
  const normalizedColor = normalizeHexColor(backgroundColor, "#111827");
  const red = parseInt(normalizedColor.slice(1, 3), 16);
  const green = parseInt(normalizedColor.slice(3, 5), 16);
  const blue = parseInt(normalizedColor.slice(5, 7), 16);
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;

  return luminance > 0.6 ? "#111111" : "#ffffff";
}

export function getProductBannerStyle(banner) {
  const normalizedBanner = normalizeProductBanners({ featured: banner }).featured;

  return {
    backgroundColor: normalizedBanner.backgroundColor,
    color: getContrastTextColor(normalizedBanner.backgroundColor),
  };
}
